(() => {
  const VIP_MESSAGE_CLASS = 'vcc-vip-support-message';
  const SUBMIT_WARNING_CLASS = 'vcc-transfer-submit-warning';
  const TERMS_LINK_CLASS = 'vcc-terms-link';
  const TERMS_FIELD_ATTR = 'data-vcc-terms-field';
  const TERMS_URL = 'https://vaicomcarol.com.br/pages/termos-e-condicoes';
  const FIELD_ATTR = 'data-vcc-vip-field';
  const VIP_MESSAGE_TEXT =
    'Seu transfer acontecerá normalmente, independentemente da contratação deste serviço. O Atendimento em Português oferece intermediação da Vai Com Carol junto à empresa de transporte em caso de necessidade. Sem ele, o contato será feito diretamente com a transportadora. O valor refere-se exclusivamente a esse atendimento adicional e não é reembolsável.';
  const SUBMIT_WARNING_TEXT =
    '⚠ Confira seus dados antes de enviar. Uma vez enviados, você tem até 48 horas antes do horário do transfer para solicitar correções sem custo. Erros não corrigidos dentro desse prazo são de sua responsabilidade e não geram reembolso.';
  const VIP_YES_LABEL = 'SIM (VALOR ADICIONAL R$125,00)';

  const normalize = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

  const hasVipToken = (value) => {
    const text = normalize(value);
    return text.includes('suporte') && text.includes('vip');
  };

  const isYesValue = (value) => normalize(value) === 'sim';

  const hasTermsToken = (value) => {
    const text = normalize(value);
    return text.includes('termos_e_condies') || (text.includes('termos') && text.includes('condicoes'));
  };

  const getAllRoots = () => {
    const roots = [document];
    const seen = new Set(roots);

    for (let index = 0; index < roots.length; index += 1) {
      roots[index].querySelectorAll('*').forEach((element) => {
        if (!element.shadowRoot || seen.has(element.shadowRoot)) return;
        seen.add(element.shadowRoot);
        roots.push(element.shadowRoot);
      });
    }

    return roots;
  };

  const getLabelText = (input, root = document) => {
    const closestLabel = input.closest('label')?.textContent;
    const forLabel = input.id ? root.querySelector(`label[for="${CSS.escape(input.id)}"]`)?.textContent : '';

    return closestLabel || forLabel || '';
  };

  const findVipRadioGroups = (root) => {
    const groups = new Set();

    root.querySelectorAll('fieldset, [role="radiogroup"]').forEach((group) => {
      const legend = group.querySelector('legend');
      const radio = group.querySelector('input[type="radio"]');

      if (hasVipToken(legend?.textContent) || hasVipToken(group.getAttribute('name')) || hasVipToken(radio?.name) || hasVipToken(radio?.id)) {
        groups.add(group);
      }
    });

    root.querySelectorAll('input[type="radio"]').forEach((radio) => {
      if (!hasVipToken(radio.name) && !hasVipToken(radio.id)) return;
      const group = radio.closest('fieldset') || radio.closest('[role="radiogroup"]') || radio.parentElement?.parentElement;
      if (group) groups.add(group);
    });

    return Array.from(groups);
  };

  const findYesRadio = (group) =>
    Array.from(group.querySelectorAll('input[type="radio"]')).find((radio) => {
      const labelText = getLabelText(radio, group);

      return isYesValue(radio.value) || isYesValue(radio.getAttribute('aria-label')) || isYesValue(labelText);
    });

  const ensureMessage = (group) => {
    let message = group.nextElementSibling?.classList?.contains(VIP_MESSAGE_CLASS) ? group.nextElementSibling : null;

    if (!message) {
      message = document.createElement('p');
      message.className = VIP_MESSAGE_CLASS;
      message.textContent = VIP_MESSAGE_TEXT;
      message.style.background = 'rgba(30, 41, 102, 0.08)';
      message.style.borderLeft = '4px solid #1e2966';
      message.style.borderRadius = '8px';
      message.style.color = '#11182f';
      message.style.fontFamily = 'Barlow, Inter, Arial, sans-serif';
      message.style.fontSize = '13px';
      message.style.fontWeight = '600';
      message.style.lineHeight = '1.45';
      message.style.margin = '10px 0 0';
      message.style.padding = '12px 14px';
      message.style.textTransform = 'none';
      group.insertAdjacentElement('afterend', message);
    }

    return message;
  };

  const applyWarningStyles = (message) => {
    message.style.background = 'rgba(224, 34, 41, 0.1)';
    message.style.border = '1px solid rgba(224, 34, 41, 0.28)';
    message.style.borderLeft = '4px solid #e02229';
    message.style.borderRadius = '8px';
    message.style.color = '#b31920';
    message.style.fontFamily = 'Barlow, Inter, Arial, sans-serif';
    message.style.fontSize = '13px';
    message.style.fontWeight = '800';
    message.style.lineHeight = '1.45';
    message.style.margin = '14px 0 10px';
    message.style.padding = '12px 14px';
    message.style.textAlign = 'left';
    message.style.textTransform = 'none';
  };

  const syncSubmitWarnings = () => {
    getAllRoots().forEach((root) => {
      root.querySelectorAll('button[type="submit"], button[data-testid="btn-form-submit"]').forEach((button) => {
        if (button.previousElementSibling?.classList?.contains(SUBMIT_WARNING_CLASS)) return;

        const message = document.createElement('p');
        message.className = SUBMIT_WARNING_CLASS;
        message.textContent = SUBMIT_WARNING_TEXT;
        applyWarningStyles(message);
        button.insertAdjacentElement('beforebegin', message);
      });
    });
  };

  const syncTermsLinks = () => {
    getAllRoots().forEach((root) => {
      root.querySelectorAll('fieldset, [role="group"]').forEach((group) => {
        const checkbox = group.querySelector('input[type="checkbox"]');
        const legend = group.querySelector('legend');

        if (!checkbox) return;
        if (!hasTermsToken(legend?.textContent) && !hasTermsToken(group.getAttribute('name')) && !hasTermsToken(checkbox.name) && !hasTermsToken(checkbox.id) && !hasTermsToken(checkbox.value)) {
          return;
        }

        group.setAttribute(TERMS_FIELD_ATTR, 'true');

        const label = checkbox.closest('label') || (checkbox.id ? root.querySelector(`label[for="${CSS.escape(checkbox.id)}"]`) : null);
        const textNode = label?.querySelector('span');
        if (!label || !textNode || textNode.querySelector(`.${TERMS_LINK_CLASS}`)) return;

        textNode.textContent = 'Li e concordo com os ';

        const link = document.createElement('a');
        link.className = TERMS_LINK_CLASS;
        link.href = TERMS_URL;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = 'termos e condições';
        link.style.color = '#1878b9';
        link.style.fontWeight = '800';
        link.style.textDecoration = 'underline';
        link.style.textUnderlineOffset = '3px';

        link.addEventListener('click', (event) => {
          event.stopPropagation();
        });

        textNode.appendChild(link);
      });
    });
  };

  const syncVipMessages = () => {
    getAllRoots().forEach((root) => {
      findVipRadioGroups(root).forEach((group) => {
        group.setAttribute(FIELD_ATTR, 'true');

        const yesRadio = findYesRadio(group);
        const radios = group.querySelectorAll('input[type="radio"]');
        if (!yesRadio || !radios.length) return;

        const yesLabel = yesRadio.closest('label') || (yesRadio.id ? root.querySelector(`label[for="${CSS.escape(yesRadio.id)}"]`) : null);
        const yesTextNode = yesLabel?.querySelector('span');
        if (yesTextNode && yesTextNode.textContent.trim() !== VIP_YES_LABEL) {
          yesTextNode.textContent = VIP_YES_LABEL;
        }

        const message = ensureMessage(group);
        message.hidden = !yesRadio.checked;

        radios.forEach((radio) => {
          if (radio.dataset.vccVipBound === 'true') return;
          radio.dataset.vccVipBound = 'true';
          radio.addEventListener('change', syncVipMessages);
          radio.addEventListener('click', () => window.setTimeout(syncVipMessages, 0));
        });
      });
    });
  };

  const init = () => {
    syncVipMessages();
    syncSubmitWarnings();
    syncTermsLinks();

    document.addEventListener('change', () => {
      syncVipMessages();
      syncSubmitWarnings();
      syncTermsLinks();
    }, true);
    document.addEventListener('click', () => {
      window.setTimeout(() => {
        syncVipMessages();
        syncSubmitWarnings();
        syncTermsLinks();
      }, 0);
    }, true);

    let attempts = 0;
    const interval = window.setInterval(() => {
      syncVipMessages();
      syncSubmitWarnings();
      syncTermsLinks();
      attempts += 1;
      if (attempts >= 40) window.clearInterval(interval);
    }, 250);

    const observer = new MutationObserver(() => {
      syncVipMessages();
      syncSubmitWarnings();
      syncTermsLinks();
      getAllRoots().forEach((root) => {
        if (root.dataset?.vccVipObserverBound === 'true') return;
        if (root.dataset) root.dataset.vccVipObserverBound = 'true';
        observer.observe(root, {
          childList: true,
          subtree: true,
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
